import {Component, OnInit} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {DialogComponent} from "../bootstrap-modal/dialog.component";

export type SearchOptionHelpDialogModel = {
  property: string;
  examples: string[];
};

export type SearchHelpDialogModel = {
  searchOptions: SearchOptionHelpDialogModel[];
};

@Component({
  templateUrl: "./search-help-dialog.template.pug",
  providers: [],
})
export class SearchHelpDialogComponent extends DialogComponent<SearchHelpDialogModel, {}>
  implements SearchHelpDialogModel, OnInit {
  public error: Error;
  public searchOptions: SearchOptionHelpDialogModel[];
  public activeIndex: number = 0;
  public activeOption: SearchOptionHelpDialogModel;

  public static show(dialogService: DialogService, model: SearchHelpDialogModel): void {
    dialogService.addDialog(SearchHelpDialogComponent, model, {backdropColor: "rgba(0, 0, 0, 0.5)"});
  }

  public setActive(index): void {
    this.activeIndex = index;
    this.activeOption = this.searchOptions[index];
  }

  ngOnInit(): void {
    if (this.searchOptions.length > 0) {
      this.setActive(0);
    }
  }

  constructor(
    public dialogService: DialogService,
  ) {
    super(dialogService);
  }
}
